import { onMounted, ref, reactive, provide, computed } from "vue";

import { UserLevel } from "@/core/UserLevel/UserLevel"
import ConfigManager from "@/config/ConfigManager";
import BzbsApi from "@/core/Http/BzbsApi";

export default function usePageClass(opts = {
    goldClass: "level-gold",
    platinumClass: "level-platinum"
}, isProvide = true) {
    const pageClass = ref("")
    const bgConfig = ref()

    const userLevels = reactive({
        isGold: false,
        isPlatinum: false
    })

    const pageBg = computed(() => {
        if (bgConfig.value != null) {
            console.log(bgConfig.value)
            let url = ConfigManager.getBlobUrl() + "/webconfig/ksam/bg-levels"
            if (userLevels.isPlatinum) {
                url += `/platinum/${bgConfig.value.platinum}`
            } else if (userLevels.isGold) {
                url += `/gold/${bgConfig.value.gold}`
            } else {
                return 'none'
            }
            return `url('${url}')` // for background-image
        }

        return 'none' // background none
    })

    const getBgConfig = function () {
        BzbsApi.connectBzbsGetBlob(ConfigManager.getBlobUrl() + "/webconfig/ksam/bg-levels/bg.json").subscribe({
            next: (res) => {
                // console.log(res)
                bgConfig.value = res.data
            }
        })
    }

    const initPage = () => {
        getBgConfig()

        let userLevel = new UserLevel();

        if (userLevel.isPlatinum()) {
            // 1 = gold
            // 2 = platinum
            pageClass.value = opts.platinumClass
            userLevels.isPlatinum = true
        } else if (userLevel.isGold()) {
            pageClass.value = opts.goldClass
            userLevels.isGold = true
        }
    }

    onMounted(initPage)

    if (isProvide) {
        provide("UserLevels", userLevels)
    }

    return {
        pageClass,
        userLevels,
        pageBg
    }
}
